import { useEffect, useState } from "react";
import { IMAGE_BASE } from "../utils/constants";

export const ImageCell = ({ logo_url }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (!logo_url) return;

      const finalUrl = logo_url.startsWith("https://")
        ? logo_url
        : `${IMAGE_BASE}${logo_url}`;

      try {
        const response = await fetch(finalUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setImageSrc(url);
      } catch (err) {
        console.error("Failed to fetch image", err);
      }
    };

    fetchImage();

    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [logo_url]);

  if (!logo_url) return <span>No Image</span>;

  return (
    <img
      src={imageSrc}
      alt="image"
      style={{ width: 40, height: 40, objectFit: "contain" }}
    />
  );
};
